module.exports = __webpack_public_path__ + "img/bg-section-05-mobile.841d2579.svg";